// extracted by mini-css-extract-plugin
export default {"statusFilter":"MerchantsOrdersHistory_statusFilter__q6JFG","label":"MerchantsOrdersHistory_label__gA30b"};